// extracted by mini-css-extract-plugin
export default {"container":"gn-z","blurb":"hn-z","links":"in-z"};